<nz-table #nestedTable [nzData]="parentTableData" [nzPageSize]="10">
  <thead>
  <!-- PARENT TABLE HEADER -->
  <tr>
    <th nzShowExpand></th>
    <th *ngFor="let pHead of parentTableHeader">{{pHead.name}}</th>
  </tr>
  </thead>
  <tbody>
  <!-- PARENT TABLE DATA -->
  <ng-template ngFor let-data [ngForOf]="nestedTable.data">
    <tr>
      <td nzShowExpand [(nzExpand)]="data.expanded"></td>
      <!-- DATA -->
      <td>{{ data.name }}</td>
      <td>{{ data.details }}</td>
      <td>{{ data.address }}</td>
      <td>{{ data.doa }}</td>
      <td>{{ data.dod }}</td>
      <!-- ACTIONS -->
      <td>
        <a (click)="openHospModal()">Edit</a>
      </td>
    </tr>
    <tr [nzExpand]="data.expanded">
      <td></td>
      <td colspan="7">
        <nz-table #innerTable [nzData]="childTableData" nzSize="middle" [nzShowPagination]="false">
          <!-- CHILD TABLE HEADER -->
          <thead>
            <tr>
              <th *ngFor="let cHead of childTableHeader">{{cHead.name}}</th>
            </tr>
          </thead>
          <tbody>
          <!-- CHILD TABLE DATA -->
          <tr *ngFor="let data of innerTable.data">
            <td>{{ data.name }}</td>
            <td>{{ data.det }}</td>
            <td>{{ data.regDetails }}</td>
            <td>{{ data.treatedFor }}</td>
            <td>{{ data.remarks }}</td>
          </tr>
          </tbody>
        </nz-table>
      </td>
    </tr>
  </ng-template>
  </tbody>

</nz-table>